import { render } from "./ProductImage.vue?vue&type=template&id=b243fbb2&scoped=true"
import script from "./ProductImage.vue?vue&type=script&lang=js"
export * from "./ProductImage.vue?vue&type=script&lang=js"

import "./ProductImage.vue?vue&type=style&index=0&id=b243fbb2&lang=scss&scoped=true"

import exportComponent from "/srv/swensa.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b243fbb2"]])

export default __exports__